export function onFirstScroll(name, callback) {
  window.ranAlready = window.ranAlready || {};
  window.ranAlready[name] = false;

  document.addEventListener('scroll', () => {
    if (window.ranAlready[name]) {
      return;
    }

    callback();

    window.ranAlready[name] = true;
  });
}
